import React from 'react'
import ProjectFormView from './projectFormView'



const AddNewProjectView = () => {
    return (
        <ProjectFormView />
    )
}

export default AddNewProjectView
